// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- Hero extras: view switcher ---- */
.NetworkPage_heroMeta__GPdV2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-5) var(--space-7);
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border-on-dark);
}
.NetworkPage_views__N7PnV {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.3rem;
  border: 1px solid var(--color-border-on-dark);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(10px);
}
.NetworkPage_view__jgSaa,
.NetworkPage_viewActive__dK82P {
  padding: 0.55rem 1.1rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  text-decoration: none;
  transition: background-color var(--dur-fast) ease, color var(--dur-fast) ease;
}
.NetworkPage_view__jgSaa {
  color: var(--color-text-muted-on-dark);
}
.NetworkPage_view__jgSaa:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}
.NetworkPage_viewActive__dK82P,
.NetworkPage_viewActive__dK82P:hover {
  color: var(--color-ink);
  background: var(--kur-gold);
}

/* ---- Toolbar: search or filter chips, plus a live result count ---- */
.NetworkPage_toolbar__fiTQw {
  position: sticky;
  top: 80px;
  z-index: 5;
  display: grid;
  gap: var(--space-4);
  margin: calc(var(--space-4) * -1) 0 var(--space-6);
  padding: var(--space-4) 0;
  background: rgba(255, 255, 255, 0.92);
  /* full-bleed bar while the content stays on the grid */
  box-shadow: 0 0 0 100vmax rgba(255, 255, 255, 0.92);
  clip-path: inset(0 -100vmax);
  backdrop-filter: saturate(1.4) blur(12px);
  border-bottom: 1px solid var(--color-border);
}
.NetworkPage_search__SPfzb {
  position: relative;
  display: block;
  max-width: 34rem;
}
.NetworkPage_searchIcon__L2RgJ {
  position: absolute;
  top: 50%;
  left: 1rem;
  width: 1.15rem;
  height: 1.15rem;
  transform: translateY(-50%);
  fill: none;
  stroke: var(--color-text-muted);
  stroke-width: 2;
  stroke-linecap: round;
  pointer-events: none;
}
.NetworkPage_search__SPfzb input {
  width: 100%;
  min-height: 3.1rem;
  padding: 0.75rem 1rem 0.75rem 2.9rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: #fff;
  font-family: var(--font-sans);
  font-size: 1rem;
  color: var(--color-ink);
  box-shadow: var(--shadow-sm);
  transition: border-color var(--dur-fast) ease, box-shadow var(--dur-fast) ease;
}
.NetworkPage_search__SPfzb input:focus {
  outline: none;
  border-color: var(--kur-amber, #c9a400);
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.3);
}
.NetworkPage_chips__X-q7f {
  display: flex;
  gap: var(--space-2);
  overflow-x: auto;
  padding: 2px 2px 4px;
  scrollbar-width: thin;
}
@media (min-width: 992px) {
  .NetworkPage_chips__X-q7f {
    flex-wrap: wrap;
    overflow: visible;
  }
}
.NetworkPage_chip__Wf8dD,
.NetworkPage_chipActive__ZiFie {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.6rem 0.5rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: #fff;
  font-family: var(--font-sans);
  font-size: 0.9rem;
  white-space: nowrap;
  color: var(--color-ink);
  cursor: pointer;
  transition: border-color var(--dur-fast) ease, background-color var(--dur-fast) ease,
    transform var(--dur-fast) ease;
}
.NetworkPage_chip__Wf8dD:hover {
  border-color: var(--color-ink);
  transform: translateY(-1px);
}
.NetworkPage_chipActive__ZiFie {
  border-color: var(--color-ink);
  background: var(--color-ink);
  color: #fff;
}
.NetworkPage_count__xTRGZ {
  min-width: 1.6rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: var(--color-cloud);
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  color: var(--color-text-muted);
}
.NetworkPage_chipActive__ZiFie .NetworkPage_count__xTRGZ {
  background: var(--kur-gold);
  color: var(--color-ink);
}
.NetworkPage_summary__HwKKJ {
  margin: 0;
  font-size: 0.95rem;
  color: var(--color-text-muted);
}
.NetworkPage_summary__HwKKJ strong {
  color: var(--color-ink);
}

/* ---- Investigator grid ---- */
.NetworkPage_grid__57HAj {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-6) var(--space-5);
  grid-template-columns: repeat(auto-fill, minmax(min(14.5rem, 100%), 1fr));
}
@media (max-width: 520px) {
  .NetworkPage_grid__57HAj {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-5) var(--space-3);
  }
}
.NetworkPage_card__RUoAh {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.NetworkPage_card__RUoAh:hover .NetworkPage_portrait__u\\+R0K img {
  transform: scale(1.04);
}
.NetworkPage_name__y-cHb {
  margin: var(--space-4) 0 var(--space-1);
  font-size: 1.08rem;
  font-weight: 500;
  line-height: 1.25;
}
.NetworkPage_specialty__z12\\+8 {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--color-ink);
}
.NetworkPage_place__nMN73 {
  margin: 0.2rem 0 0;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.NetworkPage_stats__0qEbY {
  margin: auto 0 0;
  padding-top: var(--space-3);
  display: flex;
  gap: var(--space-5);
}
.NetworkPage_stats__0qEbY > div {
  padding-top: var(--space-3);
  border-top: 2px solid var(--kur-gold);
}
.NetworkPage_stats__0qEbY dt {
  font-size: 0.7rem;
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--color-text-muted);
}
.NetworkPage_stats__0qEbY dd {
  margin: 0.1rem 0 0;
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--color-ink);
}
.NetworkPage_empty__hBMru {
  padding: var(--space-8) 0;
  text-align: center;
  color: var(--color-text-muted);
}
.NetworkPage_srOnly__VEpWd {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
@media (max-width: 520px) {
  .NetworkPage_name__y-cHb {
    font-size: 0.98rem;
  }
  .NetworkPage_stats__0qEbY {
    gap: var(--space-3);
  }
}
@media (prefers-reduced-motion: reduce) {
  .NetworkPage_chip__Wf8dD:hover {
    transform: none;
  }
}
@media (max-width: 520px) {
  .NetworkPage_views__N7PnV {
    flex-wrap: nowrap;
    max-width: 100%;
  }
  .NetworkPage_view__jgSaa,
  .NetworkPage_viewActive__dK82P {
    padding: 0.5rem 0.8rem;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/NETWORK_PAGE/NetworkPage.module.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,oBAAoB;EACpB,qCAAqC;EAErC,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,6EAA6E;AAC/E;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,qCAAqC;AACvC;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,yBAAyB;EACzB,qCAAqC;EACrC,uDAAuD;EACvD,mDAAmD;EACnD,4BAA4B;EAE5B,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,4BAA4B;EAC5B,8EAA8E;AAChF;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;;EAEE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;kCACgC;AAClC;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,yEAAyE;AAC3E;AACA;EACE;IACE,gDAAgD;IAChD,kCAAkC;EACpC;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["/* ---- Hero extras: view switcher ---- */\n.heroMeta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-5) var(--space-7);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--color-border-on-dark);\n}\n.views {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  padding: 0.3rem;\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.04);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n}\n.view,\n.viewActive {\n  padding: 0.55rem 1.1rem;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  white-space: nowrap;\n  text-decoration: none;\n  transition: background-color var(--dur-fast) ease, color var(--dur-fast) ease;\n}\n.view {\n  color: var(--color-text-muted-on-dark);\n}\n.view:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n.viewActive,\n.viewActive:hover {\n  color: var(--color-ink);\n  background: var(--kur-gold);\n}\n\n/* ---- Toolbar: search or filter chips, plus a live result count ---- */\n.toolbar {\n  position: sticky;\n  top: 80px;\n  z-index: 5;\n  display: grid;\n  gap: var(--space-4);\n  margin: calc(var(--space-4) * -1) 0 var(--space-6);\n  padding: var(--space-4) 0;\n  background: rgba(255, 255, 255, 0.92);\n  /* full-bleed bar while the content stays on the grid */\n  box-shadow: 0 0 0 100vmax rgba(255, 255, 255, 0.92);\n  clip-path: inset(0 -100vmax);\n  -webkit-backdrop-filter: saturate(1.4) blur(12px);\n  backdrop-filter: saturate(1.4) blur(12px);\n  border-bottom: 1px solid var(--color-border);\n}\n.search {\n  position: relative;\n  display: block;\n  max-width: 34rem;\n}\n.searchIcon {\n  position: absolute;\n  top: 50%;\n  left: 1rem;\n  width: 1.15rem;\n  height: 1.15rem;\n  transform: translateY(-50%);\n  fill: none;\n  stroke: var(--color-text-muted);\n  stroke-width: 2;\n  stroke-linecap: round;\n  pointer-events: none;\n}\n.search input {\n  width: 100%;\n  min-height: 3.1rem;\n  padding: 0.75rem 1rem 0.75rem 2.9rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: #fff;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  color: var(--color-ink);\n  box-shadow: var(--shadow-sm);\n  transition: border-color var(--dur-fast) ease, box-shadow var(--dur-fast) ease;\n}\n.search input:focus {\n  outline: none;\n  border-color: var(--kur-amber, #c9a400);\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.3);\n}\n.chips {\n  display: flex;\n  gap: var(--space-2);\n  overflow-x: auto;\n  padding: 2px 2px 4px;\n  scrollbar-width: thin;\n}\n@media (min-width: 992px) {\n  .chips {\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n}\n.chip,\n.chipActive {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.6rem 0.5rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: #fff;\n  font-family: var(--font-sans);\n  font-size: 0.9rem;\n  white-space: nowrap;\n  color: var(--color-ink);\n  cursor: pointer;\n  transition: border-color var(--dur-fast) ease, background-color var(--dur-fast) ease,\n    transform var(--dur-fast) ease;\n}\n.chip:hover {\n  border-color: var(--color-ink);\n  transform: translateY(-1px);\n}\n.chipActive {\n  border-color: var(--color-ink);\n  background: var(--color-ink);\n  color: #fff;\n}\n.count {\n  min-width: 1.6rem;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  background: var(--color-cloud);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  color: var(--color-text-muted);\n}\n.chipActive .count {\n  background: var(--kur-gold);\n  color: var(--color-ink);\n}\n.summary {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--color-text-muted);\n}\n.summary strong {\n  color: var(--color-ink);\n}\n\n/* ---- Investigator grid ---- */\n.grid {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-6) var(--space-5);\n  grid-template-columns: repeat(auto-fill, minmax(min(14.5rem, 100%), 1fr));\n}\n@media (max-width: 520px) {\n  .grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-5) var(--space-3);\n  }\n}\n.card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.card:hover .portrait img {\n  transform: scale(1.04);\n}\n.name {\n  margin: var(--space-4) 0 var(--space-1);\n  font-size: 1.08rem;\n  font-weight: 500;\n  line-height: 1.25;\n}\n.specialty {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--color-ink);\n}\n.place {\n  margin: 0.2rem 0 0;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n.stats {\n  margin: auto 0 0;\n  padding-top: var(--space-3);\n  display: flex;\n  gap: var(--space-5);\n}\n.stats > div {\n  padding-top: var(--space-3);\n  border-top: 2px solid var(--kur-gold);\n}\n.stats dt {\n  font-size: 0.7rem;\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n.stats dd {\n  margin: 0.1rem 0 0;\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: var(--color-ink);\n}\n.empty {\n  padding: var(--space-8) 0;\n  text-align: center;\n  color: var(--color-text-muted);\n}\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n@media (max-width: 520px) {\n  .name {\n    font-size: 0.98rem;\n  }\n  .stats {\n    gap: var(--space-3);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .chip:hover {\n    transform: none;\n  }\n}\n@media (max-width: 520px) {\n  .views {\n    flex-wrap: nowrap;\n    max-width: 100%;\n  }\n  .view,\n  .viewActive {\n    padding: 0.5rem 0.8rem;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroMeta": `NetworkPage_heroMeta__GPdV2`,
	"views": `NetworkPage_views__N7PnV`,
	"view": `NetworkPage_view__jgSaa`,
	"viewActive": `NetworkPage_viewActive__dK82P`,
	"toolbar": `NetworkPage_toolbar__fiTQw`,
	"search": `NetworkPage_search__SPfzb`,
	"searchIcon": `NetworkPage_searchIcon__L2RgJ`,
	"chips": `NetworkPage_chips__X-q7f`,
	"chip": `NetworkPage_chip__Wf8dD`,
	"chipActive": `NetworkPage_chipActive__ZiFie`,
	"count": `NetworkPage_count__xTRGZ`,
	"summary": `NetworkPage_summary__HwKKJ`,
	"grid": `NetworkPage_grid__57HAj`,
	"card": `NetworkPage_card__RUoAh`,
	"portrait": `NetworkPage_portrait__u+R0K`,
	"name": `NetworkPage_name__y-cHb`,
	"specialty": `NetworkPage_specialty__z12+8`,
	"place": `NetworkPage_place__nMN73`,
	"stats": `NetworkPage_stats__0qEbY`,
	"empty": `NetworkPage_empty__hBMru`,
	"srOnly": `NetworkPage_srOnly__VEpWd`
};
export default ___CSS_LOADER_EXPORT___;
